import React, { FunctionComponent } from "react";

import styled from "styled-components";
import { useDraggableScroll } from "../../hooks/use-draggable";

interface ListProps {
  className?: string;
  children: React.ReactNode;
  direction?: "horizontal" | "vertical";
  gap?: "small" | "medium" | "large";
  overflowX?: "scroll" | "hidden";
}

export const List: FunctionComponent<ListProps> = ({
  className,
  children,
  direction = "vertical",
  gap = "medium",
  overflowX,
}) => {
  const { ref, onMouseDown, onMouseMove, onMouseUpOrLeave, isDragging } =
    useDraggableScroll();
  return (
    <ListWrapper
      className={className || ""}
      data-direction={direction}
      data-gap={gap}
      data-overflow-x={overflowX}
      ref={ref}
      onMouseDown={direction === "horizontal" ? onMouseDown : undefined}
      onMouseMove={direction === "horizontal" ? onMouseMove : undefined}
      onMouseUp={direction === "horizontal" ? onMouseUpOrLeave : undefined}
      onMouseLeave={direction === "horizontal" ? onMouseUpOrLeave : undefined}
      style={{
        cursor:
          direction === "vertical"
            ? "inherit"
            : isDragging
            ? "grabbing"
            : "grab",
      }}
    >
      {children}
    </ListWrapper>
  );
};

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 32px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    padding-inline: 24px;
  }

  &[data-direction="horizontal"] {
    flex-direction: row;
    user-select: none;
  }
  &[data-direction="vertical"] {
    flex-direction: column;
  }

  &[data-gap="small"] {
    gap: 24px;
  }
  &[data-gap="medium"] {
    gap: 32px;
    @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
      gap: 16px;
    }
  }
  &[data-gap="large"] {
    gap: 48px;
  }

  &[data-overflow-x="scroll"] {
    overflow-x: scroll;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    /* Hide scrollbar for Chrome, Safari and Opera */
    ::-webkit-scrollbar {
      display: none;
    }
  }
  &[data-overflow-x="hidden"] {
    overflow-x: hidden;
  }
`;
